var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#003B6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54652 4.97648C9.72571 4.59062 10.2743 4.59062 10.4535 4.97648L11.5827 7.40803C11.6556 7.5649 11.8043 7.67298 11.976 7.69379L14.6375 8.01636C15.0599 8.06755 15.2294 8.58927 14.9178 8.87894L12.9542 10.7043C12.8275 10.822 12.7707 10.9969 12.804 11.1667L13.3196 13.7976C13.4015 14.2151 12.9577 14.5375 12.5859 14.3307L10.2431 13.0272C10.0919 12.9432 9.90806 12.9432 9.75691 13.0272L7.41413 14.3307C7.04235 14.5375 6.59854 14.2151 6.68037 13.7976L7.19604 11.1667C7.22931 10.9969 7.17249 10.822 7.0458 10.7043L5.08222 8.87894C4.77061 8.58927 4.94013 8.06755 5.36248 8.01636L8.02397 7.69379C8.19568 7.67298 8.34444 7.5649 8.41729 7.40803L9.54652 4.97648Z",
    fill: "#003B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankStarIcon);
export default __webpack_public_path__ + "static/media/RankStarIcon.f7f5a427e396e128394ce8cc31d7d19c.svg";
export { ForwardRef as ReactComponent };